import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { CreateProspectDto } from "../models/prospect/addProspect/prospect";

@Injectable({
  providedIn: "root",
})
export class ProspectsDetailService {
  private ProspectManagementBaseURL =
    environment.baseUrl + "/ProspectManagement";
  constructor(private _http: HttpClient) {}

  getProspectById(
    id: string
  ): Observable<GenericResponseDto<CreateProspectDto>> {
    return this._http.get<GenericResponseDto<CreateProspectDto>>(
      this.ProspectManagementBaseURL +
        "/GetProspectByAccountNumber?accountNumber=" +
        id
    );
  }

  createNewContact(
    payload: CreateProspectDto
  ): Observable<GenericResponseDto<CreateProspectDto>> {
    return this._http.post<GenericResponseDto<CreateProspectDto>>(
      this.ProspectManagementBaseURL + "/AddProspectContact",
      payload
    );
  }

  UpdateProspectContactBySerialNumberAndAccountNumber(
    payload: CreateProspectDto
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.ProspectManagementBaseURL +
        "/UpdateProspectContactBySerialNumberAndAccountNumber",
      payload
    );
  }
}
